// import React from "react";
// import "./WhyUs.css";
// import {
//   FaShieldAlt,
//   FaTools,
//   FaUsers,
//   FaTruckMoving,
//   FaHeart,
//   FaLightbulb,
//   FaHammer,
//   FaCubes,
// } from "react-icons/fa";

// function WhyUs() {
//   const items = [
//     {
//       icon: <FaShieldAlt />,
//       title: "Risk Management",
//       text: "We carefully identify, analyze and manage risks at every stage to ensure smooth execution of projects without delays.",
//     },
//     {
//       icon: <FaTruckMoving />,
//       title: "Deliver on Time",
//       text: "Our planning and dedicated team allow us to complete projects within the promised timeframe.",
//     },
//     {
//       icon: <FaHammer />,
//       title: "Quality Construction",
//       text: "We focus on high construction standards, modern techniques and practical solutions to deliver strong results.",
//     },
//     {
//       icon: <FaHeart />,
//       title: "We are Passionate",
//       text: "Our commitment and passion push us to give the best outcome for every client.",
//     },
//     {
//       icon: <FaUsers />,
//       title: "Professional Team",
//       text: "A skilled team of engineers and consultants works closely with clients to provide expert guidance.",
//     },
//     {
//       icon: <FaTools />,
//       title: "Certified Tools",
//       text: "We use advanced and certified tools to ensure safety, accuracy and efficiency in our work.",
//     },
//     {
//       icon: <FaCubes />,
//       title: "Top Materials",
//       text: "We use only the finest raw materials to ensure long-lasting and strong structures.",
//     },
//     {
//       icon: <FaLightbulb />,
//       title: "Smart Ideas",
//       text: "Innovation is at the core of what we do. We provide smart and cost-effective solutions.",
//     },
//   ];

//   return (
//     <div className="whyus">
//       <h2 className="whyus-title">Why Choose Us</h2>

//       <div className="whyus-grid">
//         {items.map((item, index) => (
//           <div className="whyus-card" key={index}>
//             <div className="whyus-icon">{item.icon}</div>
//             <h3 className="whyus-card-title">{item.title}</h3>
//             <p className="whyus-card-text">{item.text}</p>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

// export default WhyUs;

import React from "react";
import "./WhyUs.css";
import {
  FaShieldAlt,
  FaTruckMoving,
  FaHammer,
  FaHeart,
  FaUsers,
  FaTools,
  FaCubes,
  FaLightbulb,
} from "react-icons/fa";

function WhyUs() {
  const items = [
    {
      icon: <FaShieldAlt />,
      title: "Risk Management",
      text: "We carefully identify, analyze and manage risks at every stage to ensure smooth execution of projects without delays.",
    },
    {
      icon: <FaTruckMoving />,
      title: "Deliver on Time",
      text: "Our planning and dedicated team allow us to complete projects within the promised timeframe.",
    },
    {
      icon: <FaHammer />,
      title: "Quality Construction",
      text: "We focus on high construction standards, modern techniques and practical solutions to deliver strong results.",
    },
    {
      icon: <FaHeart />,
      title: "We are Passionate",
      text: "Our commitment and passion push us to give the best outcome for every client.",
    },
    {
      icon: <FaUsers />,
      title: "Professional Team",
      text: "A skilled team of engineers and consultants works closely with clients to provide expert guidance.",
    },
    {
      icon: <FaTools />,
      title: "Certified Tools",
      text: "We use advanced and certified tools to ensure safety, accuracy and efficiency in our work.",
    },
    {
      icon: <FaCubes />,
      title: "Top Materials",
      text: "We use only the finest raw materials to ensure long-lasting and strong structures.",
    },
    {
      icon: <FaLightbulb />,
      title: "Smart Ideas",
      text: "Innovation is at the core of what we do. We provide smart and cost-effective solutions.",
    },
  ];

  return (
    <div className="whyus-section">
      <div className="our-services-heading-container">
        <h2 className="ourteam-heading">Why choose us</h2>
        <p>
          We focus on quality, honesty, and smooth service, making sure your
          project is built the right way with care and commitment.
        </p>
      </div>

      <div className="whyus-container">
        {items.map((item, index) => (
          <div className="whyus-card" key={index}>
            <div className="whyus-icon">{item.icon}</div>
            <h3 className="whyus-title">{item.title}</h3>
            <p className="whyus-text">{item.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default WhyUs;
